/**
 * ProMemberBlock.tsx
 *
 * Reusable Pro Membership CTA section extracted from HomepageClient.tsx §7 PRO DOOR.
 * Renders the exact same JSX as the homepage inline block.
 *
 * Used on:
 *   - Homepage (HomepageClient.tsx)
 *   - Blog post pages (BlogPostPageClient.tsx)
 *
 * CSS: class names (.hp-pro-door, .hp-pro-door-bg) are unchanged from the
 * homepage original. Background image is wired in globals.css. No new tokens.
 *
 * Cycle 76-A: TinaMarkdown removed. body is rendered as plain text paragraphs.
 * Full rich-text rendering restored in 76-D RSC island extraction.
 */

'use client';

const ArrowRight = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="13 6 19 12 13 18" />
  </svg>
);

interface ProMemberBlockProps {
  headline?: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any;
  ctaLabel?: string | null;
  ctaHref?: string | null;
}

export default function ProMemberBlock({
  headline,
  body,
  ctaLabel,
  ctaHref,
}: ProMemberBlockProps) {
  // body is a plain string in 76-A; split on double-newline for paragraph breaks
  const paragraphs = typeof body === 'string'
    ? body.split(/\n\n+/).filter(Boolean)
    : [];

  return (
    <section className="hp-pro-door" id="pro">
      <div className="hp-pro-door-bg hp-pro-door-bg--lars-cut" aria-hidden="true" />
      <h2>{headline}</h2>
      <div>
        {paragraphs.length > 0
          ? paragraphs.map((p, i) => <p key={i}>{p}</p>)
          : null}
      </div>
      <a
        href={ctaHref ?? '/pro-member'}
        className="btn btn-secondary btn-lg"
      >
        {ctaLabel}
        <ArrowRight size={16} />
      </a>
    </section>
  );
}
